import React, { useState, useEffect, Fragment, useContext } from "react";
import LayoutDashboard from "../../Components/Layout/LayoutDashboard";
import {
  Fab,
  Typography,
  Grid,
  Button,
  Tooltip,
  Hidden,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import { Link } from "react-router-dom";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import SubCategoryContext from "../../Reducers/SubCategories/SubCategoryContext";
import MaterialTable from "material-table";
import MethodGet from "../../Config/Services";
import Spinner from "../../Complements/Spinner";
import SubCategoriesAdd from './AddAdmin';
import SubCategoriesEdit from "./Edit";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  // Se renderiza el titulo y los botones de las vista de tabla asi como el ajuste de mobile *-
  container: {
    paddingTop: theme.spacing(5),
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
    paddingBottom: theme.spacing(4),
    paddingInlineEnd: theme.spacing(2),
  },
  // Se renderiza el titulo y los botones de las vista de tabla asi como el ajuste de mobile *-
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    marginBlockEnd: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  input: {
    display: "none",
  },
  typography: {
    //margin: theme.spacing(0, 1, 2, 2),
  },
  // Estilo de tablas Container

  // Se renderiza el titulo y los botones de las vista de tabla asi como el ajuste de mobile *-
  titleTbl: {
    //backgroundColor:'#8115CF',
    background: "linear-gradient(50deg, #0288d1 33%, #26c6da 100%)",
    color: "white",
    fontSize: "large",
    height: "80px",
    borderRadius: "15px",
    paddingTop: "5px",
    marginBottom: "20px",
    whiteSpace: "nowrap",
  },
  btnPlus: {
    display: "absolute",
    marginTop: "40px",
    zIndex: 2,
    position: "relative",
    marginRight: -20,
  },
  btnReverse: {
    display: "absolute",
    marginTop: "40px",
    zIndex: 2,
    position: "relative",
    marginLeft: -20,
  },
  fabGreen: {
    color: theme.palette.common.white,
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[600],
    },
  },
  fabReverse: {
    color: "white",
    backgroundColor: "#dc6daf",
    "&:hover": {
      backgroundColor: "#bd5d96",
    },
  },
  // Se renderiza el titulo y los botones de las vista de tabla asi como el ajuste de mobile *-
  IconArrowBack: {
    paddingTop: "11px",
  },
}));

const SubCategories = (props) => {
  const classes = useStyles();

  const [cargando, spinnerCargando] = useState(false);

  const { subcategories, success, getSubcategoriesCategory } =
    useContext(SubCategoryContext);

  const StateSubCategoryContext = useContext(SubCategoryContext);
  const { saveCurrentSubcategory, getSubcategories, deleteSubcategory } = StateSubCategoryContext;

  const SelectSubCategories = (subcategory) => {
    saveCurrentSubcategory(subcategory);
  };

  const [subcategoryId, saveSubcategoryId] = useState(null);

  //obtenemos el producto de session storage
  let CategoryStorageID = JSON.parse(sessionStorage.getItem("account"));


  useEffect(() => {
    getSubcategories();
    spinnerCargando(true);
  }, [success]);

  const [openModalAdd, setOpenModalAdd] = React.useState(false);

  const handleClickOpenModalAdd = () => {
    setOpenModalAdd(true);
  };
  const handleCloseModalAdd = () => {
    setOpenModalAdd(false);
  };

  const [openModalEdit, setOpenModalEdit] = React.useState(false);

  const handleClickOpenModalEdit = () => {
    setOpenModalEdit(true);
  };
  const handleCloseModalEdit = () => {
    setOpenModalEdit(false);
    saveSubcategoryId(null);
  };


  if (!cargando) return <Spinner />;

  return (
    <LayoutDashboard>
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          style={{
            marginTop: 100,
            background: "linear-gradient(50deg, #3f51b5 33%, indigo 100%)",
            color: "white",
            borderRadius: 15,
            marginLeft: 25,
            marginRight: 25,
          }}
        >
          <Typography component="h1" variant="h4">
            Subcategorias
          </Typography>
          <Typography variant="subtitle1" gutterBottom>
            Registros de todas las subcategorias
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          align="right"
          style={{ marginRight: 30, marginTop: -30 }}
        >
          <Fab
            className={classes.fabGreen}
            aria-label="add"
            size="medium"
            onClick={() => handleClickOpenModalAdd()}
          >
            <Tooltip title="Agregar Subcategoria" aria-label="Agregar Subcategoria">
              <AddIcon />
            </Tooltip>
          </Fab>
        </Grid>
      </Grid>
      {/* separacion */}

      <Hidden only={["xs", "sm"]}>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          style={{ marginRight: 30, marginLeft: 30, marginTop: 10 }}
        >
          <MaterialTable
            title=""
            columns={[
              { title: "Clave", field: "id_subcategorie" },
              {
                title: "Subcategoria",
                field: "name_subcategorie",
                render: (rowData) => <p>{rowData.name_subcategorie}</p>,
              },
            ]}
            data={subcategories}
            options={{
              headerStyle: {
                backgroundColor: "none",
                color: "#000",
                fontSize: "16px",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
              },

              actionsColumnIndex: -1,
            }}
            actions={[
              (rowData) => ({
                icon: "delete",
                tooltip: "Eliminar SubCategoria",
                onClick: () => deleteSubcategory(rowData.id_subcategorie),
              }),
            ]}
            components={{
              Action: (props) => (
                <Fragment>
                  <Button
                    variant="contained"
                    style={{
                      textTransform: "none",
                      background: "white",
                    }}
                    onClick={() => {
                      saveSubcategoryId(props.data.id_subcategorie);
                      handleClickOpenModalEdit();
                    }
                    }
                    size="small"
                  >
                    <Tooltip
                      title="Editar Subcategoria"
                      aria-label="Editar Subcategoria"
                    >
                      <EditIcon style={{ color: "blue" }} />
                    </Tooltip>
                  </Button>
                  <Button
                    variant="contained"
                    style={{ textTransform: "none", background: "white" }}
                    size="small"
                    onClick={() => deleteSubcategory(props.data.id_subcategorie)}
                  >
                    <Tooltip
                      title="Eliminar Subcategoria"
                      aria-label="Editar subcategoria"
                    >
                      <DeleteIcon style={{ color: "red" }} />
                    </Tooltip>
                  </Button>
                </Fragment>
              ),
            }}
            localization={{
              pagination: {
                labelDisplayedRows: "{from} - {to} de {count}",
                labelRowsSelect: "Columnas",
                firstTooltip: "Primera Pagina",
                previousTooltip: "Anterior",
                nextTooltip: "Siguiente",
                lastTooltip: "Ultima Página",
              },
              toolbar: {
                searchTooltip: "Buscar",
                searchPlaceholder: "Buscar",
              },
              header: {
                actions: "Opciones",
              },
              body: {
                emptyDataSourceMessage: "No Hay subcategorias que Mostrar",
                filterRow: {
                  filterTooltip: "Buscar",
                },
              },
            }}
          />
        </Grid>
      </Hidden>

      <Hidden only={["md", "lg", "xl"]}>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          style={{ marginRight: 30, marginLeft: 30, marginTop: 10 }}
        >
          <MaterialTable
            title=""
            columns={[
              {
                title: "Subcategoria",
                field: "name_subcategorie",
                render: (rowData) => <p>{rowData.name_subcategorie}</p>,
              },
            ]}
            data={subcategories}
            options={{
              headerStyle: {
                backgroundColor: "none",
                color: "#000",
                fontSize: "16px",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
              },

              actionsColumnIndex: -1,
            }}
            detailPanel={[
              {
                tooltip: "Ver más",
                render: (rowData) => {
                  return (
                    <div
                      style={{
                        color: "black",
                        marginLeft: 50,
                      }}
                    >
                      <p>Opciones: </p>
                      <p>
                        <Fragment>
                          <Button
                            variant="contained"
                            style={{
                              textTransform: "none",
                              background: "white",
                            }}
                            onClick={() => {
                              saveSubcategoryId(rowData.id_subcategorie);
                              handleClickOpenModalEdit();
                            }
                            }
                            size="small"
                          >
                            <Tooltip
                              title="Editar Subcategoria"
                              aria-label="Editar Subcategoria"
                            >
                              <EditIcon style={{ color: "blue" }} />
                            </Tooltip>
                          </Button>
                          <Button
                            variant="contained"
                            style={{ textTransform: "none", background: "white" }}
                            size="small"
                            onClick={() => deleteSubcategory(rowData.id_subcategorie)}
                          >
                            <Tooltip
                              title="Eliminar Subcategoria"
                              aria-label="Editar subcategoria"
                            >
                              <DeleteIcon style={{ color: "red" }} />
                            </Tooltip>
                          </Button>
                        </Fragment>
                      </p>
                    </div>
                  );
                },
              },
            ]}
            localization={{
              pagination: {
                labelDisplayedRows: "{from} - {to} de {count}",
                labelRowsSelect: "Columnas",
                firstTooltip: "Primera Pagina",
                previousTooltip: "Anterior",
                nextTooltip: "Siguiente",
                lastTooltip: "Ultima Página",
              },
              toolbar: {
                searchTooltip: "Buscar",
                searchPlaceholder: "Buscar",
              },
              body: {
                emptyDataSourceMessage: "No Hay Subcategorias que Mostrar",
                filterRow: {
                  filterTooltip: "Buscar",
                },
              },
            }}
          />
        </Grid>
      </Hidden>

      <SubCategoriesAdd
        modal={openModalAdd}
        handleClose={handleCloseModalAdd}
        setOpenModalAdd={setOpenModalAdd}
      />
      {subcategoryId !== null && (
        <SubCategoriesEdit
          modal={openModalEdit}
          handleClose={handleCloseModalEdit}
          setOpenModalEdit={setOpenModalEdit}
          id={subcategoryId}
        />
      )}
    </LayoutDashboard>
  );
};

export default SubCategories;